import {
  PropsWithTheme,
  OwnUpGridItem,
  OwnUpBody,
  ALOE_100,
  MOSS_100
} from '@rategravity/own-up-component-library';
import styled from 'styled-components';

export const FastLinksListheading = styled(OwnUpBody)`
  font-size: 24px;
  color: ${ALOE_100};
  margin: 0;
`;

export const FastLinksOwnUpGridItem = styled(OwnUpGridItem)``;

export const FastLinksListWrapper = styled.div`
  background-color: ${MOSS_100};
  border-radius: 8px;
  padding: 16px;
  margin-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(5)}px`};
  position: sticky;
  top: 80px;

  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('md')} {
    margin-top: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;

export const FastLinksList = styled.ul`
  padding: 0;
  list-style-type: none;
  color: #000000;
`;

export const FastLinksItem = styled.li`
  padding-top: 10px;
`;

export const Link = styled.a`
  color: #000000;
`;
